<template>
	<div
		class="editable_table"
		:style="cssVars"
	>
		<div class="container">
			<table
				border="0"
				v-if="parsedTable"
			>
				<caption
					v-if="parsedTable.caption"
					v-html="parsedTable.caption"
				></caption>
				<thead v-if="parsedTable.header">
					<tr>
						<th
							v-for="(column, index) in parsedTable.header"
							:key="index"
							v-html="column.c"
						></th>
					</tr>
				</thead>
				<tbody v-if="parsedTable.body">
					<tr
						v-for="(row, index) in parsedTable.body"
						:key="index"
					>
						<td
							v-for="(cell, index) in row"
							:key="index"
							v-html="cell.c"
						></td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    table: {},
		size: {},
  },

  computed: {
    parsedTable() {
      if (this.table) {
        return JSON.parse(this.table);
      } else {
        return null;
      }
    },

    cssVars() {
      return {
        '--size': this.size ? this.size : '1 / span 12',
      };
    },
  },

  watch: {},

  methods: {},

  components: {},

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.container {
	overflow-x:auto;
	display: grid;
  grid-template-columns: repeat(12, 1fr);
	padding: 0 calc(var(--spacer) * 2);
	max-width: 1068px;

	@media (max-width: $lg) {
      padding: 0 calc(var(--spacer) * 1);
    }
}

table {
	border-spacing: var(--spacer);
	border-collapse: collapse;
	grid-column: var(--size);

	@media (max-width: $lg) {
      grid-column: span 12;
    }

	caption {
		font-size: 14px;
		font-style: italic;
		margin-bottom: var(--spacer);
		color: var(--cpmec-grey-dark);
	}
	
	tr {
		border-top: 1px solid var(--cpmec-grey);

		&:first-of-type {
			border-top: 0 solid var(--cpmec-grey);
			border-bottom: 1px solid var(--cpmec-grey);
		}
	}

  th {
		padding: calc(var(--spacer) / 2) calc(var(--spacer) / 2);
		border-right: 1px solid var(--cpmec-grey);
		color: var(--cpmec-grey);

		&:last-child {
			border-right: 0 solid var(--cpmec-grey);
		}
	}

	td {
		padding: calc(var(--spacer) / 2) calc(var(--spacer) / 2);
		border-right: 1px solid var(--cpmec-grey);
		color: var(--cpmec-grey);

		&:last-child {
			border-right: 0 solid var(--cpmec-grey);
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/EditableTable.vue